<template>
    <el-dialog :title="dialogTitle" :visible.sync="leaveDialogVisible" width="520px"  :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog custom-tip-form-dialog">
        <p class="dialog-txt-tip">操作后人员状态变为「待离职」，请在完成交接事宜后操作【确认离职】</p>
        <div class="avatar_name_wrap mb_16">
            <img :src="user_info.avatar || defaultImg" alt="" class="header_img">
            <div>
                <p class="user_name">{{ user_info.user_name }}</p>
                <p><span>{{ user_info.department_path }}</span></p>
            </div>
        </div>
        <el-form ref="formData" :rules="formDataRules" :model="formData" label-position="top" v-loading="loading">
            <el-form-item label="离职日期" prop="quit_date">
                <el-date-picker  format="yyyy-MM-dd" placeholder="请选择离职日期" type="date" v-model="formData.quit_date" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="离职类型" prop="quit_type">
                <el-select placeholder="请选择离职类型" v-model="formData.quit_type">
                    <el-option :label="item.type_value" :value="item.type_id" @click.native="handleSelectTypeChange(item)" v-for="(item,index) in dimission_type_list" :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="离职原因" prop="quit_reason">
                <el-select placeholder="请选择离职原因" v-model="formData.quit_reason">
                    <el-option :label="item" :value="item" v-for="(item,index) in dimission_type_list.find(find => find.type_id == formData.quit_type) ? dimission_type_list.find(find => find.type_id == formData.quit_type).reason : []" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="离职备注" prop="quit_note" class="form-item-textarea">
                <el-input :rows="3" maxlength="200" placeholder="请输入离职备注" show-word-limit type="textarea" v-model="formData.quit_note"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary"  :disabled="btnDisabled" @click.stop="handleDialogConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getQuitReason,applyQuit,quitInfo,editQuitInfo} from "@/api";

export default {
    name: "leaveOffice",
    props: {
        leaveDialogVisible: {
            type: Boolean,
            default: false
        },
        user_info: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            loading:false,
            defaultImg: require("@/assets/images/default.jpg"),
            dialogTitle: "办理离职",
            user_detail: {
                header_img: "",
                name: "刘晓宁",
                did_name: "总经办/创新产品部",
            },
            formData: {
                id:'',
                quit_date: "",
                quit_type: "",
                quit_reason: "",
                quit_note: ""
            },
            formDataRules: {
                quit_date: [{ required: true, message: '请选择离职日期' }],
                quit_type: [{ required: true, message: '请选择离职类型' }],
                quit_reason: [{ required: true, message: '请选择离职原因' }]
            },
            dimission_type_list: [],
            reasonList: [],
            btnDisabled:false

        }
    },
    created() {
        // 有id证明是编辑
        if(this.user_info.id){
            this.formData.id = this.user_info.id
        }
        this.getQuitReason()
    },
    methods: {
        getQuitInfo(){
            this.loading = true
            quitInfo({id:this.formData.id}).then(res => {
                if (res.code === 200) {
                    let {quit_date,quit_type,quit_reason,quit_note } = res.data
                    this.formData.quit_date = quit_date
                    this.formData.quit_type = String(quit_type)
                    this.formData.quit_reason = quit_reason
                    this.formData.quit_note = quit_note

                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        getQuitReason(){
            getQuitReason({}).then(res => {
                if (res.code === 200) {
                    this.dimission_type_list = res.data
                    if(this.formData.id){
                        this.getQuitInfo()
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        handleDialogClose() {
            this.$emit('update:leaveDialogVisible', false)
        },


        handleSelectTypeChange(item) {
            this.formData.quit_reason = ''
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = {
                        uid : this.user_info.user_id,
                        quit_date : this.formData.quit_date,
                        quit_type : this.formData.quit_type,
                        quit_reason : this.formData.quit_reason,
                        quit_note : this.formData.quit_note,
                    }
                    this.btnDisabled = true
                    if(this.formData.id){
                        postData.id = this.formData.id
                        editQuitInfo(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit('update:leaveDialogVisible', false)
                                        this.$emit('success')
                                    }
                                })
                            } else {
                                this.$message.error(res.message)
                            }
                            this.btnDisabled = false
                        })
                    }else{
                        applyQuit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit('update:leaveDialogVisible', false)
                                        this.$emit('success')
                                    }
                                })
                            } else {
                                this.$message.error(res.message)
                            }
                            this.btnDisabled = false
                        })
                    }

                }
            })
        }
    }
}
</script>
